import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './App'
import './index.css'

export const createRoot = ViteReactSSG({ routes }, ({ isClient }) => {
  // Apply saved theme before hydration to avoid a flash (client only;
  // localStorage is not available during static generation).
  if (isClient) {
    const saved = localStorage.getItem('msp-theme') || 'dark'
    if (saved === 'dark') document.documentElement.classList.add('dark')
  }
})
